import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SignedOutHeader } from '../../components/SignedOutHeader';
import { SignedOutWrapper } from '../../components/SignedOutWrapper';

import { FormSignIn } from './components/FormSignIn';

export const SignIn: React.FC = () => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  return (
    <SignedOutWrapper>
      <SignedOutHeader isMobile={isMobile} />
      <FormSignIn isMobile={isMobile} />
    </SignedOutWrapper>
  );
};
